import { useAtomValue, useSetAtom } from 'jotai'
import * as R from 'ramda'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { routeParams } from '../@types/route'
import { filterState } from '../atoms/filterState'
import { settingsState } from '../atoms/settingsState'
import { getNenjiFromHash } from '../utils/hash'

export type NenjiFilterHandlers = {
  reset(): void
}

type NenjiType = {
  label: string
  checked: boolean
}

export const NenjiFilter = forwardRef<NenjiFilterHandlers>((_, ref) => {
  const updateFilter = useSetAtom(filterState)
  const { grade } = useAtomValue(settingsState)
  const { state }: { state: routeParams | null } = useLocation()

  const [nenjis, setNenjis] = useState<NenjiType[]>(() => {
    return R.map(g => {
      return { label: g.label, checked: false }
    }, grade)
  })

  useImperativeHandle(ref, () => {
    const reset = () => {
      const labels = R.pluck('label', nenjis)
      setIdsChecked(labels, false)
    }
    return {
      reset,
    }
  })

  useEffect(() => {
    if (state) {
      // 移動してきた
      const { connectedNenjis } = state
      const nenjis = connectedNenjis.split('')
      setIdsChecked(nenjis, true)
    } else {
      // 突然やってきた
      const connectedString = getNenjiFromHash()
      setIdsChecked(connectedString, true)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const setIdsChecked = (ids: string[], check: boolean) => {
    setNenjis(prevState =>
      prevState.map(item => {
        return {
          ...item,
          checked: ids.includes(item.label) ? check : item.checked,
        }
      })
    )
  }

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target

    const values = R.pluck(
      'label',
      temporaryState(value, checked).filter(r => r.checked)
    )
    const n = R.map(Number, values)

    // 自身のGUIのチェックたちを更新する
    setIdsChecked([value], checked)

    // 全体のフィルタを更新する
    updateFilter(prev => {
      return {
        ...prev,
        nenjis: n,
      }
    })
  }

  const temporaryState = (label: string, checked: boolean) => {
    return nenjis.map(value => {
      return value.label === label ? { ...value, checked } : value
    })
  }

  return (
    <div className="py-1">
      {nenjis.map(nenji => {
        return (
          <span
            key={nenji.label}
            className="inline-flex items-center gap-1.5 py-1.5 px-3 m-1 rounded-md text-xs font-medium bg-gray-100 text-gray-800"
          >
            <input
              className="cursor-pointer"
              id={String(nenji.label)}
              type="checkbox"
              value={nenji.label}
              onChange={onChangeInput}
              checked={nenji.checked}
            />
            <label className="cursor-pointer" htmlFor={nenji.label}>
              {nenji.label}年次
            </label>
          </span>
        )
      })}
    </div>
  )
})
